"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var KeyCodes_1 = require("../../utils/KeyCodes");

require("./iconPicker.scss");

var iconpickerClassName = 'vis-cf-iconpicker';
var uniqueId = ca_ui_toolkit_1.lodash.uniqueId;

var IconPickerComponent =
/** @class */
function (_super) {
  __extends(IconPickerComponent, _super);

  function IconPickerComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      open: false
    };
    _this.attachRef = react_1.default.createRef();
    return _this;
  }

  IconPickerComponent.prototype.render = function () {
    var _this = this;

    var open = this.state.open;
    var _a = this.props,
        icons = _a.icons,
        className = _a.className,
        style = _a.style,
        flyoutExtraOptions = _a.flyoutExtraOptions,
        _b = _a.selectedIcon,
        selectedIcon = _b === void 0 ? '' : _b;
    var orientation = this.props.orientation;

    if (typeof orientation === 'undefined') {
      orientation = document.body.dir === 'rtl' ? 'bottomLeft' : 'bottomRight';
    }

    return react_1.default.createElement("div", {
      className: iconpickerClassName + " " + className,
      ref: this.attachRef,
      style: style
    }, react_1.default.createElement(ca_ui_toolkit_1.SVGIcon, {
      tabIndex: 0,
      size: 'small',
      className: 'vis-cf-svgIcon',
      iconId: selectedIcon.iconId,
      onClick: this._handleClose.bind(this),
      onKeyDown: function onKeyDown(e) {
        return _this._handleKey(e);
      }
    }), open && react_1.default.createElement(ca_ui_toolkit_1.Flyout, __assign({
      id: uniqueId('icon-picker__') + "-flyout",
      "data-tid": 'icon-picker__flyout'
    }, flyoutExtraOptions, {
      "aria-hidden": open,
      placement: orientation,
      domNodeToAttachTo: this.attachRef.current,
      hideArrow: true,
      offset: 2,
      onClose: this._handleClose.bind(this),
      className: iconpickerClassName + "__flyout"
    }), icons.map(this._displayIcon.bind(this))));
  };

  IconPickerComponent.prototype._displayIcon = function (icon, index) {
    var _this = this;

    var displayLabel = icon.shapeId === 'none';
    var className = displayLabel ? iconpickerClassName + "__text" : iconpickerClassName + "__cell";
    return react_1.default.createElement("div", {
      key: index,
      tabIndex: 0,
      className: className,
      onClick: function onClick() {
        return _this._handleSelect(icon);
      },
      onKeyDown: function onKeyDown(e) {
        return _this._handleKey(e, icon);
      },
      title: icon.label
    }, !displayLabel && react_1.default.createElement(ca_ui_toolkit_1.SVGIcon, {
      iconId: icon.iconId,
      alt: icon.label,
      ariaLabelledby: uniqueId('icon-picker-svg'),
      verticalAlign: 'inherit'
    }), displayLabel && icon.label);
  };

  IconPickerComponent.prototype._handleClose = function () {
    this.setState({
      open: !this.state.open
    });
  };

  IconPickerComponent.prototype._handleSelect = function (icon) {
    this.props.onIconSelected && this.props.onIconSelected(icon); // close the flyout after selection

    this.setState({
      open: false
    });
  };

  IconPickerComponent.prototype._handleKey = function (e, icon) {
    if (e.keyCode === KeyCodes_1.KeyCodes.ENTER || e.keyCode === KeyCodes_1.KeyCodes.SPACE) {
      if (icon) {
        this._handleSelect(icon);
      } else {
        this._handleClose();
      } // Prevent browser's default action: space does a PageDown


      e.preventDefault();
    }
  };

  return IconPickerComponent;
}(react_1.Component);

exports.default = mobx_react_1.observer(IconPickerComponent);
